import React, { useState } from 'react';
const CEDRINE_RED_CARPET = 'https://cdn.magicpatterns.com/uploads/twXary7GPte8GMkGftj8Tj/ChatGPT_Image_Mar_13,_2026,_05_40_52_PM.png';
const CEDRINE_PARTY = 'https://cdn.magicpatterns.com/uploads/uFoHNyW6jcDoguNwUxDwK3/download.jpg';
interface BlogPost {
  id: string;
  title: string;
  date: string;
  image?: {
    src: string;
    caption: string;
  };
  content: React.ReactNode;
}
const BLOG_POSTS: BlogPost[] = [{
  id: 'post1',
  title: 'Predictions about CDs next album',
  date: 'March 8, 2003',
  image: {
    src: CEDRINE_PARTY,
    caption: "Cedrine looking GORGEOUS at her bday party!!! She's def planning something big!!!"
  },
  content: <div className="space-y-4 text-base" data-id="element-8">
        <p data-id="element-9">
          OMG you guys!!! I was talking to my friend Sarah (her cousin works at
          the record label!!!) and she said Cedrine is in the studio RIGHT
          NOW!!! 😱😱😱
        </p>
        <p data-id="element-10">
          I am literally shaking. I predict the next album is going to be super
          edgy, maybe some rock guitars??? But still with her AMAZING angelic
          voice obviously!!! 💖
        </p>
        <p data-id="element-11">
          I think the lead single will be called "Shattered Hearts (But I'm
          Still Standing)". It just sounds like something she would write after
          the whole drama last year. I CANNOT WAIT!!! I'm saving all my
          allowance to buy 5 copies!!!
        </p>
      </div>
}, {
  id: 'post2',
  title: 'MGM is a LOSER (she deserves better)',
  date: 'February 22, 2003',
  image: {
    src: CEDRINE_RED_CARPET,
    caption: 'Cedrine on the red carpet being a QUEEN while MGM could NEVER 😤'
  },
  content: <div className="space-y-4 text-base text-red-800" data-id="element-12">
        <p className="text-xl font-bold uppercase" data-id="element-13">
          I AM SO MAD RIGHT NOW!!! 😡😡😡
        </p>
        <p data-id="element-14">
          Did you guys see what MGM said about Cedrine in Tiger Beat magazine???
          He is such a LOSER!!! How dare he say she lip-syncs!!! She has the
          voice of a literal ANGEL!!!
        </p>
        <p data-id="element-15">
          He is just jealous because his band is failing and Cedrine is the
          QUEEN OF POP!!! If anyone here likes MGM you can LEAVE MY PAGE RIGHT
          NOW!!! I mean it!!! 😤
        </p>
        <p data-id="element-16">
          Cedrine deserves so much better. We love you Cedrine!!! Don't listen
          to the haters!!!
        </p>
      </div>
}, {
  id: 'post3',
  title: "What 'She's All That and Tore' REALLY means",
  date: 'January 15, 2003',
  content: <div className="space-y-4 text-base" data-id="element-17">
        <p data-id="element-18">
          Okay, so I was listening to track 4 ("She's All That and Tore") on
          repeat last night (I cried for THREE HOURS when I first heard this
          song 😭), and I think I finally figured out the hidden meaning.
        </p>
        <p data-id="element-19">
          When she sings{' '}
          <em data-id="element-20">"Like a butterfly with a broken wing, I still try to sing"</em>...
          she's talking about the pressures of fame!!! The butterfly is her
          innocence, and the broken wing is the paparazzi!!!
        </p>
        <p data-id="element-21">
          This song literally changed my life. It speaks to my soul. Nobody
          understands me like Cedrine does. ~*~So deep~*~ ✨
        </p>
      </div>
}];
export function BlogSection() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section id="blogs" className="w-full max-w-3xl mx-auto mb-12" data-id="element-22">
      <div className="bg-[#ffb6c1] retro-border p-6 retro-shadow" data-id="element-23">
        <h2 className="text-3xl md:text-4xl text-center text-[#cc0066] mb-6" style={{
        textShadow: '1px 1px 0px #fff'
      }} data-id="element-24">
          ~*~ NEWS & BLOGS ~*~
        </h2>

        <div className="space-y-8" data-id="element-25">
          {BLOG_POSTS.map((post, index) => <div key={post.id} className="bg-white border-4 border-dotted border-[#ff69b4] p-5" data-id="element-26">
              <div className="border-b-2 border-[#ff1493] pb-3 mb-4" data-id="element-27">
                <h3 className="text-xl md:text-2xl text-[#660044] font-bold" data-id="element-28">
                  {post.title}
                </h3>
                <div className="flex justify-between text-sm text-gray-600 mt-1" data-id="element-29">
                  <span data-id="element-30">Posted: {post.date}</span>
                  <span data-id="element-31">by: CedrineLuvr4eva</span>
                </div>
              </div>

              {post.image && <div className="mb-4 text-center" data-id="element-32">
                  <img src={post.image.src} alt={post.image.caption} className="mx-auto w-full max-w-xs object-cover border-4" style={{
              borderStyle: 'ridge',
              borderColor: '#ff69b4'
            }} data-id="element-33" />
                  <p className="text-xs text-[#ff1493] mt-1 italic" data-id="element-34">
                    {post.image.caption}
                  </p>
                </div>}

              {expandedId === post.id ? <div data-id="element-35">
                  {post.content}
                  <button onClick={() => setExpandedId(null)} className="mt-4 text-[#0000ff] hover:text-[#ff1493] underline font-bold text-base" data-id="element-36">
                    [Collapse Post]
                  </button>
                </div> : <div data-id="element-37">
                  <div className="line-clamp-2 opacity-70 text-base" data-id="element-38">
                    {post.content}
                  </div>
                  <button onClick={() => setExpandedId(post.id)} className="mt-3 text-[#0000ff] hover:text-[#ff1493] underline font-bold text-base" data-id="element-39">
                    [Read Full Post...]
                  </button>
                </div>}

              {index < BLOG_POSTS.length - 1 && <div className="text-center text-[#ff69b4] mt-6 tracking-widest text-lg" data-id="element-40">
                  ★ ★ ★ ★ ★
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}